var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames+ '_text'},[_vm._v(" 你收到一条新视频类型消息，请打开抖音app查看 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }